import { Component, inject, input } from '@angular/core';
import { Product } from '@mwe/models';
import { HeadlineService } from '../../../headline/headline.service';
import { ProductTariffCardTemplateComponent } from '../../tariff-card-template/product-tariff-card-template.component';

@Component({
  selector: 'mwe-tariff-card-stromrueck',
  templateUrl: './tariff-card-stromrueck.component.html',
  providers: [HeadlineService],
  imports: [ProductTariffCardTemplateComponent],
})
export class TariffCardStromrueckComponent {
  product = input.required<Product>();

  headlineService = inject(HeadlineService);
}
